import MultipleTooltip from './MultipleTooltip';

export default MultipleTooltip;
